export const FOCUSABLE_ELM_QUERY = 'a[href], area[href], input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';

const getBounds = (el) => {
  const newElms = Array.prototype.slice.call(el.querySelectorAll(FOCUSABLE_ELM_QUERY)) || [];
  
  return [newElms[0], newElms[newElms.length - 1]];
}

export default {
  bind: function(el, { value={} }, vnode) {
    console.log('[trap focus]', value);
    const isLive = !!value.live;
    let firstElm = null;
    let lastElm = null;
    if (!isLive) {
      [firstElm, lastElm] = getBounds(el);
    }

    el.addEventListener('keydown', function(e) {
      if (e.keyCode === 9) {
        if (isLive) {
          [firstElm, lastElm] = getBounds(el);
        }

        console.log('[trap focus]', firstElm, lastElm);

        if (e.shiftKey) {
          if (document.activeElement === firstElm) {
            e.preventDefault();
            lastElm.focus();
          }
        } else {
          if (document.activeElement === lastElm) {
            e.preventDefault();
            firstElm.focus();
          }
        }
      }

      // esc
      if (e.keyCode == 27 && value.escFunc) {
        e.preventDefault();
        value.escFunc();        
      }
    });
  },
}